<template>
  <!-- <img src="@/assets/img/community_banner.jpg" class="w-full max-h-[25rem] min-h-[11.25rem] object-cover" /> -->
  <BoardHeader />

  <main class="w-full max-w-[82.75rem] mx-auto mt-14 px-4 sm:px-6 lg:px-8">
    <header class="flex flex-col items-center justify-center mb-10">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">{{ boardLists.find((boardList) => boardList.id === parseInt(boardId))?.name }}</h1>
      <p class="text-gray-500">다양한 소식과 정보를 확인하세요.</p>
    </header>

    <!-- 본문 -->
    <section class="border-b border-gray-200 pb-6 mb-8">
      <h3 class="text-2xl font-bold text-gray-900 text-center mb-4">
        {{ postDetail.postTitle }}
      </h3>
      <div class="flex justify-center items-center text-sm text-gray-500 gap-3">
        <span>{{ postDetail.postAuthor }}</span>
        <span class="w-px h-3 bg-gray-300"></span>
        <span>{{ formDate(postDetail.createdDateTime) }}</span>
        <span class="w-px h-3 bg-gray-300"></span>
        <span>조회수 {{ postDetail.postHit }}</span>
      </div>

      <div class="flex w-full justify-end mt-4 gap-2" v-if="$store.state.account.id == postDetail.postAuthorId || $store.state.level.id == 10">
        <router-link
          :to="'/board/write/' + boardId + '/' + postDetail.postId"
          class="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
          수정
        </router-link>
        <button type="button" @click="deletePost" class="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-red-600 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          삭제
        </button>
      </div>
    </section>

    <div class="w-full pb-10 mb-6 border-b border-gray-200 min-h-[200px] prose max-w-none">
      <section v-html="postDetail.postContent"></section>
    </div>

    <!-- 첨부파일 목록 -->
    <div v-if="postDetail.attachments && postDetail.attachments.length > 0" class="mb-6 bg-gray-50 rounded-lg p-4">
      <p class="text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
          />
        </svg>
        첨부파일 ({{ postDetail.attachments.length }})
      </p>
      <ul class="space-y-2">
        <li v-for="attachment in postDetail.attachments" :key="attachment.id" class="flex items-center justify-between bg-white rounded-md px-4 py-3 border border-gray-200">
          <div class="flex items-center min-w-0 flex-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 mr-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <div class="min-w-0 flex-1">
              <p class="text-sm font-medium text-gray-900 truncate">{{ attachment.fileName || attachment.name }}</p>
              <p class="text-xs text-gray-500">{{ formatFileSize(attachment.fileSize || attachment.size) }}</p>
            </div>
          </div>
          <a
            :href="'https://eduwind-api.nodeblack.net' + (attachment.filePath || attachment.url)"
            target="_blank"
            download
            class="ml-4 inline-flex items-center gap-1 px-3 py-1.5 text-sm text-blue-600 bg-blue-50 rounded-md hover:bg-blue-100 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            다운로드
          </a>
        </li>
      </ul>
    </div>

    <!-- 태그 표시 -->
    <div v-if="postDetail.postTags && postDetail.postTags.length > 0" class="mb-10 flex flex-wrap gap-2">
      <span v-for="tag in postDetail.postTags" :key="tag" class="px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-sm"> #{{ tag }} </span>
    </div>

    <div class="flex w-full justify-end mb-10 gap-2" v-if="$store.state.account.id == postDetail.postAuthorId || $store.state.level.id == 10">
      <router-link
        :to="'/board/write/' + boardId + '/' + postDetail.postId"
        class="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
        수정
      </router-link>
      <button type="button" @click="deletePost" class="inline-flex items-center gap-1 px-3 py-1.5 text-sm text-red-600 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          />
        </svg>
        삭제
      </button>
    </div>

    <!-- 댓글 -->
    <div class="mb-16">
      <div class="mb-6">
        <p class="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          댓글 <span class="text-blue-600">{{ activeCommentCount }}</span>
        </p>
        <ul class="space-y-4">
          <template v-for="com in postComments" :key="com.commentId">
            <li class="bg-gray-50 rounded-lg p-4" v-if="com.isDel !== 'Y'">
              <div class="flex justify-between items-start mb-2">
                <div class="flex items-center gap-2">
                  <p class="font-semibold text-gray-900">{{ com.memberName }}</p>
                  <span xclass="text-xs text-gray-400">{{ formDate(com.createdDateTime) }}</span>
                </div>
                <button
                  class="text-xs text-gray-400 hover:text-red-600 transition-colors"
                  @click="deleteComments(com.commentId)"
                  v-if="$store.state.account.id == com.memberIdx || $store.state.level.id == 10"
                >
                  삭제
                </button>
              </div>
              <div class="text-gray-700 text-sm leading-relaxed" v-html="convertComments(com.commentContent)"></div>
            </li>
          </template>
        </ul>
      </div>

      <div
        class="bg-white border border-gray-200 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent"
        v-if="$store.state.account.id !== null && $store.state.level.id > 1"
      >
        <textarea name="comment" v-model="state.commentContent" rows="3" class="w-full p-4 border-none resize-none focus:ring-0 text-sm" placeholder="댓글을 입력해주세요."></textarea>
        <div class="bg-gray-50 px-4 py-2 flex justify-end border-t border-gray-100">
          <button type="button" @click="writeComments" class="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 transition-colors">등록</button>
        </div>
      </div>

      <div class="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center text-gray-500 text-sm" v-else>로그인 후 댓글을 작성할 수 있습니다.</div>
    </div>

    <div class="flex justify-center mb-20">
      <router-link :to="'/board/' + boardId" class="px-8 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors shadow-sm">목록으로</router-link>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { formDate } from "@/assets/js/util.js";
import { useRoute, useRouter } from "vue-router";
import BoardHeader from "./components/boardHeader.vue";
const route = useRoute();
const router = useRouter();

const postDetail = ref([]);
const postComments = ref([]);

const activeCommentCount = computed(() => {
  return postComments.value.filter((comment) => comment.isDel !== "Y").length;
});

const boardId = route.params.boardId;
const postId = route.params.postId;

const boardLists = ref([
  { id: 5, name: "영유아부" },
  { id: 6, name: "유치부" },
  { id: 7, name: "유년부" },
  { id: 8, name: "초등부" },
  { id: 9, name: "청소년부" },
  { id: 10, name: "대학청년부" },
  { id: 11, name: "구역/장년" },
]);

const state = ref({
  commentContent: null,
});

const getPost = async () => {
  try {
    if (postId) {
      const { data } = await axios.get(`/new_api/post/${postId}`);
      console.log(data);

      if (data.code === "032") {
        alert("열람 권한이 없습니다.");
        router.go(-1);
      }

      postDetail.value = data.data.post;
      postDetail.value.postContent = postDetail.value.postContent.replace(/<br \/>/g, "\n");
      // URL 변경: http://118.67.134.110:18080/ -> https://eduwind-api.nodeblack.net
      postDetail.value.postContent = postDetail.value.postContent.replace(/http:\/\/118\.67\.134\.110:18080\//g, "https://eduwind-api.nodeblack.net/");
      postComments.value = data.data.comments;
    } else {
      console.error("올바르지 않은 접근입니다.");
    }
  } catch (err) {
    console.error(err);
  }
};

const deletePost = async () => {
  const isConfirmed = window.confirm("정말 삭제하시겠습니까?");

  if (isConfirmed) {
    try {
      const res = await axios.delete(`/new_api/post/delete/${postId}`);
      console.log(res.data);

      if (res.data.message === "OK") {
        alert("삭제되었습니다.");
        const board_page = () => {
          if (boardId === "1" || boardId === "2" || boardId === "3" || boardId === "4") {
            return "community";
          } else {
            return "board";
          }
        };
        router.push("/" + board_page() + "/" + boardId);
      }
    } catch (error) {
      console.error(error);
    }
  }
};

// 댓글 줄바꿈
const convertComments = (content) => {
  return content.replace(/\n/g, "<br>");
};

const writeComments = async () => {
  try {
    const param = {
      postId: postId,
      commentContent: state.value.commentContent,
    };
    const res = await axios.post("/new_api/comment/new", param);
    console.log(res);
    document.location.reload();
  } catch (error) {
    console.error(error);
  }
};

const deleteComments = async (comId) => {
  const isConfirmed = window.confirm("정말 삭제하시겠습니까?");

  if (isConfirmed) {
    try {
      const res = await axios.delete(`/new_api/comment/delete/${comId}`);
      console.log(res.data);

      if (res.data.message === "OK") {
        alert("삭제되었습니다.");
        document.location.reload();
      } else {
        alert("예기치 못한 에러가 발생했습니다.\n문제 지속시 고객센터로 문의 바랍니다.");
      }
    } catch (error) {
      console.error(error);
    }
  }
};

// 파일 크기 포맷팅
const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

onMounted(async () => {
  await getPost();
});
</script>
